module.exports = __webpack_public_path__ + "img/ncf.7db2451.png";